const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

// Sheets and Excel quote cells on export, and addresses pasted out of a mail
// client arrive angle-bracketed. Neither spelling resolves server-side, and an
// address that resolves to no account rejects its whole batch -- so unwrap here
// rather than send the decoration verbatim and have the upload fail on addresses
// that do exist.
//
// Only a balanced pair is stripped. A one-sided strip would silently rewrite the
// address: `'brien@x.com` is a legal local part, and dropping its leading quote
// would queue a different account for deletion.
const unwrapToken = (token) => {
  let out = token.trim()

  // RFC 4180 quoting: a quoted cell wraps in " and escapes an inner quote by
  // doubling it.
  if (out.length >= 2 && out.startsWith('"') && out.endsWith('"')) {
    out = out.slice(1, -1).replace(/""/g, '"').trim()
  }

  // `a@b.com` inside angle brackets, with or without a display name in front.
  const angled = out.match(/^[^<>]*<([^<>]+)>$/)
  if (angled) out = angled[1].trim()

  return out
}

// A dropped token is silently either a header cell or a malformed address, so the
// caller can only report a single "dropped" count, not which case applied.
export function parseCsvEmails(csvText) {
  const tokens = (csvText || '')
    .split(/\r\n|\r|\n/)
    .flatMap((line) => line.split(','))
    .map((token) => unwrapToken(token).toLowerCase())
    .filter((token) => token.length > 0)

  const emails = []
  const seen = new Set()
  let droppedCount = 0

  tokens.forEach((token) => {
    if (!EMAIL_PATTERN.test(token)) {
      droppedCount += 1
      return
    }
    if (seen.has(token)) {
      droppedCount += 1
      return
    }
    seen.add(token)
    emails.push(token)
  })

  return { emails, droppedCount }
}

export function chunkArray(items, size) {
  const chunks = []
  for (let i = 0; i < items.length; i += size) {
    chunks.push(items.slice(i, i + size))
  }
  return chunks
}
